<template>
  <div class="width100 margin-auto">
    <!-- 头部 -->
    <!-- 内容· -->
    <div class="backwhite width98 margin-auto">
      <div class="pad-bot20 f16 width98 textalign-left dimensional">
        预览报销单
      </div>
      <!-- 内容表单 -->
      <div class="width100 invoice width98 margin-auto pad-bot10">
        <div id="printTest">
          <p class="f14 margin-top20 textalign-center" style="color: #6a7589">
            {{ companytitle }}
          </p>
          <p class="f24 margin-top10 dimensional textalign-center">
            《{{ protitle }}》研发项目经费报销单
          </p>
          <div
            class="
              width96
              pad-top10
              margin-auto
              flex-betweenwrap
              margin-top20
              f12
            "
            style="color: #6a7589"
          >
            <p class="width100 flex-betweenwrap">
              <span>单据编号: {{ serial }}</span>
              <span>报销日期: {{ prodatatime }} </span>
            </p>
            <p class="width100 flex-betweenwrap">
              <span>所属单位: {{ companytitle }}</span>
              <span>单位: 元</span>
            </p>
          </div>
          <div
            class="width96 margin-auto backwhite margin-top10 border-rd3"
            style="border: 2px solid #878787"
          >
            <table class="width100 textalign-left" style="color: #6a7589">
              <tr>
                <td class="width15 bordertopnone">费用类别</td>
                <td class="width20 bordertopnone">{{ fee_type }}</td>
                <td class="width15 bordertopnone">类别明细</td>
                <td class="width40 bordertopnone borderrightnone">
                  {{ smallfee_type }}
                </td>
              </tr>
              <tr>
                <td class="width15">报销内容</td>
                <td class="width20 borderrightnone textalign-left" colspan="3">
                  <span class="pad-left5">{{ reimbursement }}</span>
                </td>
              </tr>
              <tr>
                <td class="width15">金额</td>
                <td class="width20 borderrightnone" colspan="4">
                  人民币（大写）：{{ bigmoney }}
                  <span class="margin-left10">￥:{{ reimbursementmoney }}</span>
                </td>
              </tr>
              <tr>
                <td class="width15">项目负责人</td>
                <td class="width20">{{ manager_name }}</td>
                <td class="width15">财务负责人</td>
                <td class="width40 borderrightnone">{{ cwmanger }}</td>
              </tr>
              <tr>
                <td class="width15">报销人</td>
                <td class="width40 borderrightnone" colspan="4">
                  {{ realnamepro }}
                </td>
              </tr>
            </table>
          </div>
          <div class="flex width96 margin-auto pad-top10 textalign-left">
            <div class="width30">
              <span>制单：</span> <span>{{ realnamepro }}</span>
            </div>
            <div class="width30">
              <span>审核：</span><span>{{ manager_name }}</span>
            </div>
            <div class="width30">
              <span>财务审核：</span><span>{{ cwmanger }}</span>
            </div>
          </div>
        </div>
      </div>

      <p class="margin-top10 textalign-left f12" style="color: #6a7589">
        虚线内为打印内容,打印前请核对！
      </p>
      <div
        class="border-rd3 margin-top10 textalign-left"
        v-for="(item, index) in filearr"
        :key="index"
      >
        <span
          class="cursorpointer linkfile"
          @click="seafile(item)"
          style="color: #2f6cff"
          >附件： {{ item.original_name }}</span
        >
      </div>
      <div class="textalign-right margin-top20">
        <el-button @click="filemouseenter()">日 志</el-button>
        <el-button @click="Examine()" v-if="deptitle == 1 && check_status == 3"
          >审 批</el-button
        >
        <el-button @click="Turndown()" v-if="deptitle == 1 && check_status != 2"
          >驳 回</el-button
        >
        <el-button @click="dialognull()">取 消</el-button>
        <el-button
          type="primary"
          class="cursorpointer margin-top20"
          v-print="'#printTest'"
          @click="Savechanges()"
        >
          打 印
        </el-button>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisibleLogs"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="logsbox"
      style="z-index: 100000"
    >
      <p class="textalign-left f16">日志</p>
      <div style="height: 400px" class="margin-top50">
        <el-steps direction="vertical" class="vertical">
          <el-step
            v-for="(item, index) in contlog"
            :key="index"
            :title="item.log"
            :description="'日期 :' + item.check_time"
          ></el-step>
        </el-steps>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisibleLogs = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
    
<script>
import {
  entrdfeecate,
  entrdfeedetail,
  entrdfeecheck,
} from "@/api/newhead/newhead.api";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisibleLogs: false,
      proid: "",
      protitle: "",
      pronumber: "",
      protime: "",
      progress: "",
      promanager: "",
      manager_name: "",
      cwmanger: "",
      proresearch: "",
      procooperation: "",
      fee_type: "",
      fee_typeid: "",
      options: [],
      smalloptions: [],
      smallfee_type: "",
      smallfee_typeid: "",
      companytitle: "",
      prodatatime: "",
      reimbursement: "",
      reimbursementmoney: "",
      bigmoney: "",
      serial: "",
      user: {
        project_id: "",
        fee_id: "",
      },
      head: {
        token: window.sessionStorage.getItem("token"),
      },
      filearr: [],
      // fileid: [],
      proddtime: "",
      realnamepro: "",
      costrowid: "",
      deptitle: "",
      check_status: "",
    };
  },

  methods: {
    moneychange(str) {
      var num = parseFloat(str);
      var strOutput = "",
        strUnit = "仟佰拾亿仟佰拾万仟佰拾元角分";
      num += "00";
      var intPos = num.indexOf(".");
      if (intPos >= 0) {
        num = num.substring(0, intPos) + num.substr(intPos + 1, 2);
      }
      strUnit = strUnit.substr(strUnit.length - num.length);
      for (var i = 0; i < num.length; i++) {
        strOutput +=
          "零壹贰叁肆伍陆柒捌玖".substr(num.substr(i, 1), 1) +
          strUnit.substr(i, 1);
      }
      strOutput
        .replace(/零角零分$/, "整")
        .replace(/零[仟佰拾]/g, "零")
        .replace(/零{2,}/g, "零")
        .replace(/零([亿|万])/g, "$1")
        .replace(/零+元/, "元")
        .replace(/亿零{0,3}万/, "亿")
        .replace(/^元/, "零元");

      this.bigmoney = strOutput;
    },

    Savechanges() {
      BUS.$emit("financial", "yes");
    },
    dialognull() {
      BUS.$emit("financial", "yess");
    },
    Examine() {
      entrdfeecheck({
        id: this.costrowid,
        change_to_status: 4,
      }).then((res) => {
        if (res.data.code == 200) {
          BUS.$emit("financial", "yes");
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    Turndown() {
      entrdfeecheck({
        id: this.costrowid,
        change_to_status: 2,
      }).then((res) => {
        if (res.data.code == 200) {
          BUS.$emit("financial", "yes");
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    seafile(item) {
      var url = window.g.Apisrc + item.url;
      window.open(url);
    },
    filemouseenter() {
      this.dialogVisibleLogs = true;
    },
  },

  created() {
    this.Apisrc = window.g.ApiUrl + "/ent_rd_fee/uploader";
    this.limit = window.g.imgNum;
    this.companytitle = window.sessionStorage.getItem("companytitle");
    this.deptitle = window.sessionStorage.getItem("deptitle");
    // 获取分类
    entrdfeecate({}).then((res) => {
      if (res.data.code == 200) {
        this.options = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    this.costrowid = window.sessionStorage.getItem("costrowid");
    // 详情
    entrdfeedetail({ id: window.sessionStorage.getItem("costrowid") }).then(
      (res) => {
        if (res.data.code == 200) {
          this.proid = res.data.data.project.title;
          this.protitle = res.data.data.project.title;
          this.pronumber = res.data.data.project.project_number;
          this.protime = res.data.data.project.start_date;
          this.progress = res.data.data.project.progress_text;
          this.promanager = res.data.data.project.manager;
          this.manager_name = res.data.data.dev_admin;
          this.cwmanger = res.data.data.finance_admin;
          this.check_status = res.data.data.check_status;
          this.proresearch = res.data.data.project.research_dev_title;
          this.procooperation = res.data.data.project.cooperation;
          this.fee_type = res.data.data.big_class.name;
          this.fee_typeid = res.data.data.big_class.id;
          this.smallfee_typeid = res.data.data.small_class.id;
          this.smallfee_type = res.data.data.small_class.name;
          this.reimbursement = res.data.data.detail;
          this.reimbursementmoney = res.data.data.amount;
          this.filearr = res.data.data.file;
          this.user.project_id = res.data.data.project.id;
          this.user.fee_id = res.data.data.id;
          this.serial = res.data.data.serial;
          this.realnamepro = res.data.data.realname;
          this.prodatatime = res.data.data.pay_date;
          this.contlog = res.data.data.log;
          var num = parseFloat(res.data.data.amount);
          var strOutput = "",
            strUnit = "仟佰拾亿仟佰拾万仟佰拾元角分";
          num += "00";
          var intPos = num.indexOf(".");
          if (intPos >= 0) {
            num = num.substring(0, intPos) + num.substr(intPos + 1, 2);
          }
          strUnit = strUnit.substr(strUnit.length - num.length);
          for (var i = 0; i < num.length; i++) {
            strOutput +=
              "零壹贰叁肆伍陆柒捌玖".substr(num.substr(i, 1), 1) +
              strUnit.substr(i, 1);
          }
          strOutput
            .replace(/零角零分$/, "整")
            .replace(/零[仟佰拾]/g, "零")
            .replace(/零{2,}/g, "零")
            .replace(/零([亿|万])/g, "$1")
            .replace(/零+元/, "元")
            .replace(/亿零{0,3}万/, "亿")
            .replace(/^元/, "零元");

          this.bigmoney = strOutput;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      }
    );
  },
  mounted() {
    BUS.$on("costrowid", (data) => {
      this.costrowid = data;
      entrdfeedetail({ id: data }).then((res) => {
        if (res.data.code == 200) {
          this.check_status = res.data.data.check_status;
          this.proid = res.data.data.project.title;
          this.protitle = res.data.data.project.title;
          this.pronumber = res.data.data.project.project_number;
          this.protime = res.data.data.project.start_date;
          this.progress = res.data.data.project.progress_text;
          this.promanager = res.data.data.project.manager;
          this.manager_name = res.data.data.dev_admin;
          this.cwmanger = res.data.data.finance_admin;
          this.proresearch = res.data.data.project.research_dev_title;
          this.procooperation = res.data.data.project.cooperation;
          this.fee_type = res.data.data.big_class.name;
          this.fee_typeid = res.data.data.big_class.id;
          this.smallfee_typeid = res.data.data.small_class.id;
          this.smallfee_type = res.data.data.small_class.name;
          this.reimbursement = res.data.data.detail;
          this.reimbursementmoney = res.data.data.amount;
          this.filearr = res.data.data.file;
          this.serial = res.data.data.serial;
          this.user.project_id = res.data.data.project.id;
          this.user.fee_id = res.data.data.id;
          this.realnamepro = res.data.data.realname;
          this.prodatatime = res.data.data.pay_date;
          this.contlog = res.data.data.log;
          var num = parseFloat(res.data.data.amount);
          var strOutput = "",
            strUnit = "仟佰拾亿仟佰拾万仟佰拾元角分";
          num += "00";
          var intPos = num.indexOf(".");
          if (intPos >= 0) {
            num = num.substring(0, intPos) + num.substr(intPos + 1, 2);
          }
          strUnit = strUnit.substr(strUnit.length - num.length);
          for (var i = 0; i < num.length; i++) {
            strOutput +=
              "零壹贰叁肆伍陆柒捌玖".substr(num.substr(i, 1), 1) +
              strUnit.substr(i, 1);
          }
          strOutput
            .replace(/零角零分$/, "整")
            .replace(/零[仟佰拾]/g, "零")
            .replace(/零{2,}/g, "零")
            .replace(/零([亿|万])/g, "$1")
            .replace(/零+元/, "元")
            .replace(/亿零{0,3}万/, "亿")
            .replace(/^元/, "零元");

          this.bigmoney = strOutput;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    });
  },
};
</script>
    
<style scoped>
/* 调用window.print()时生效的样式 */
@media print {
  @page {
    /* 横向 */
    /* size: landscape; */
    /* 去除浏览器默认页眉页脚 */
    margin: 0;
  }
  /* 给需要打印的区域内或同级不需要打印的元素加上这个类 */
  .noprint {
    display: none;
  }
  /* 这里的id我用于选中modal，然后给其中背景色设置为透明，去掉弹窗头和脚及阴影 */
  #printTest {
    /* 默认打印内容区背景色*/
    /* -webkit-print-color-adjust: exact; */
    border: solid white !important;
    background-color: #fff !important;
  }
}

/* 需要打印的区域*/
.printable {
  display: block;
}
.invoice {
  width: 100%;
  line-height: 30px;
  border-radius: 3px;
  margin: 20px 0 0 0;
  background: #ecf8f9;
  border: 1px dashed #52c5cb;
}
table {
  border: 1px solid #ecf8f9;
}
td {
  border-right: 1px solid #ecf8f9;
  border-top: 1px solid #ecf8f9;
  height: 40px;
  padding-left: 10px;
}
.bordertopnone {
  border-top: none;
}
.borderrightnone {
  border-right: none;
}
.inputinner >>> .el-input__inner {
  border: none;
}
.inputinner >>> .el-button {
  border: none;
}
.linkfile:hover {
  border-bottom: 1px solid #2f6cff;
}
.coer {
  width: 15px;
  overflow: hidden;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
.vertical >>> .el-step__icon {
  position: relative;
  left: 5px;
  top: -5px;
  z-index: 1;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 12px;
  height: 12px;
  background: rgb(3, 189, 3) !important;
  color: rgb(3, 189, 3);
  font-size: 12px;
  box-sizing: border-box;
  background: #fff;
  transition: 0.15s ease-out;
}
.vertical >>> .el-step__icon.is-text {
  border-radius: 50%;
  border: 1px solid;
  border-color: inherit;
}
.vertical >>> .el-step.is-vertical .el-step__line {
  width: 1px;
  top: 0;
  bottom: 0;
  left: 11px;
}
.vertical >>> .el-step.is-vertical .el-step__title {
  line-height: 24px;
  padding-bottom: 8px;
  color: black;
}
</style>
    